import { Box, useTheme } from '@mui/material'

import {
  BackdropPopup,
  ButtonApp,
  GridContainer,
  GridItem,
  TextBold,
  TextParagraph,
  TextSubTitle,
} from 'presentation/components/elements'
import { StyledRating } from 'presentation/styles/index.styled'
import {
  backText,
  conditionsAndObservationsTitleText,
  daysText,
  destinationText,
  includePriceByPersonText,
  maxCapacityText,
  nightsText,
  notIncludeTitleText,
  peopleText,
  sinceText,
  stayText,
} from 'presentation/constant/globals'
import ImageIcon from 'presentation/assets/images/picture.png'
import { convertStringPrice } from 'presentation/utils/format'
import { RenderList } from './components'

type AvailableDestinationModalProps = {
  isOpenModal: boolean
  handleCloseModal: () => void
  image: string
  destinationName: string
  description: string
  price: number
  includedByPrice: string[]
  dontIncludedByPrice: string[]
  paymentConditions: string[]
  numberDays: number
  maxCapacity: number
  numberNights: number
  rating: number
}
export default function AvailableDestinationModal({
  image,
  destinationName,
  description,
  price,
  numberDays,
  numberNights,
  includedByPrice,
  dontIncludedByPrice,
  rating,
  isOpenModal,
  handleCloseModal,
  paymentConditions,
  maxCapacity,
}: AvailableDestinationModalProps) {
  const theme = useTheme()
  const secondaryColor = theme.palette.secondary.main
  const greyColor = theme.palette.secondary.main

  return (
    <BackdropPopup openBackdrop={isOpenModal} padding="0">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          width: '900px',
          borderRadius: '10px',
        }}
      >
        <img
          src={image || ImageIcon}
          alt={`${image || ImageIcon}`}
          style={{ borderRadius: '10px', height: '385px', width: '100%' }}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: '36px',
            padding: '0 40px 40px 40px',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '13px',
              }}
            >
              <TextBold color={secondaryColor} fontSize="34px">
                {destinationName}
              </TextBold>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <TextParagraph color={secondaryColor} fontSize="14px" fontWeight={300}>
                  {destinationText}
                </TextParagraph>
                <StyledRating value={rating} disabled />
              </Box>
            </Box>
            <Box sx={{ marginBottom: '10px' }}>
              <TextSubTitle color={secondaryColor} fontSize="18px">
                {sinceText} <span style={{ fontWeight: 300 }}>USD {convertStringPrice(price)}</span>
              </TextSubTitle>
            </Box>
            <GridContainer columnSpacing="40px">
              <GridItem md={6} lg={6}>
                <TextParagraph fontSize="14px">{description}</TextParagraph>
              </GridItem>
              <GridItem md={3} lg={3}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <TextSubTitle fontSize="14px" color={greyColor}>
                    {stayText}
                  </TextSubTitle>
                  <TextParagraph fontSize="14px" color={greyColor} fontWeight={300}>
                    {numberDays} {daysText} {numberNights} {nightsText}
                  </TextParagraph>
                </Box>
              </GridItem>
              <GridItem md={3} lg={3}>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                  <TextSubTitle fontSize="14px" color={greyColor}>
                    {maxCapacityText}
                  </TextSubTitle>
                  <TextParagraph fontSize="14px" color={greyColor} fontWeight={300}>
                    {maxCapacity} {peopleText}
                  </TextParagraph>
                </Box>
              </GridItem>
            </GridContainer>
          </Box>
          <Box sx={{ display: 'flex', flexDirection: 'column', marginTop: '35px', gap: '10px' }}>
            <TextSubTitle fontSize="14px" color={secondaryColor}>
              *{includePriceByPersonText}
            </TextSubTitle>
            <GridContainer columnSpacing="40px">
              <GridItem md={6} lg={6}>
                <RenderList title="INCLUYE" listToRender={includedByPrice} />
              </GridItem>
              <GridItem md={6} lg={6}>
                <RenderList title={notIncludeTitleText} listToRender={dontIncludedByPrice} />
              </GridItem>
            </GridContainer>
          </Box>
          <Box sx={{ marginTop: '23px' }}>
            <RenderList
              title={conditionsAndObservationsTitleText}
              listToRender={paymentConditions}
            />
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '34px' }}>
            <ButtonApp onClick={handleCloseModal}>{backText}</ButtonApp>
          </Box>
        </Box>
      </Box>
    </BackdropPopup>
  )
}
